/**
 * The contrast follow-up strings (pedagogy spec §5.4, step 2.6): the "Nästa steg" offer, the
 * prediction, its verdict, and the badge of an inserted similar problem. Kept apart from the rest of
 * the practice dictionary, like `today/dict.ts`; `index.ts` spreads both languages into it.
 */
import type { LocalizedDictionary } from "@client/i18n";

export const contrastDict: LocalizedDictionary = {
  sv: {
    "practice.contrast.title": "Kontrastuppgift",
    "practice.contrast.hint": "Bara en sak ändras. Förutsäg först, räkna sedan.",
    "practice.contrast.badge": "Ändrar en sak",
    "practice.contrast.start": "Gör kontrastuppgiften",
    "practice.contrast.eyebrow": "Det här har ändrats sedan förra uppgiften:",
    "practice.contrast.variesLabel": "Det som ändras:",
    "practice.contrast.added": "Kontrastuppgiften kommer härnäst.",
    "practice.prediction.label": "Din förutsägelse",
    "practice.prediction.increases": "Ökar",
    "practice.prediction.decreases": "Minskar",
    "practice.prediction.unchanged": "Ändras inte",
    "practice.prediction.required": "Välj en förutsägelse först.",
    "practice.prediction.right": "Din förutsägelse stämde.",
    "practice.prediction.wrong": "Din förutsägelse stämde inte.",
    "practice.prediction.chosen": "Du valde",
    "practice.prediction.expected": "Rätt svar",
    "practice.similar.badge": "Samma idé",
  },
  en: {
    "practice.contrast.title": "Contrast problem",
    "practice.contrast.hint": "Only one thing changes. Predict first, then solve.",
    "practice.contrast.badge": "Varies one thing",
    "practice.contrast.start": "Try the contrast problem",
    "practice.contrast.eyebrow": "This has changed since the previous problem:",
    "practice.contrast.variesLabel": "What changes:",
    "practice.contrast.added": "The contrast problem comes next.",
    "practice.prediction.label": "Your prediction",
    "practice.prediction.increases": "Increases",
    "practice.prediction.decreases": "Decreases",
    "practice.prediction.unchanged": "Does not change",
    "practice.prediction.required": "Choose a prediction first.",
    "practice.prediction.right": "Your prediction was right.",
    "practice.prediction.wrong": "Your prediction was not right.",
    "practice.prediction.chosen": "You chose",
    "practice.prediction.expected": "The right one was",
    "practice.similar.badge": "Same idea",
  },
};
